import React, { useEffect, useState } from 'react';
import DataTable from 'components/DataTable';
import { fetchUserRequestedItems } from 'services/api/userRequestedItem';
import { DATE_FORMATS, formatDate, getPageLimit, showError, updatePageLimit } from 'utils';
import { tableStyles } from '../../../css/tableStyles';
import styles from './index.module.scss';
import CustomLink from 'components/TableLink';

const filters: { [p: string]: any; page: number } = {
  page: 0,
};

const columns = [
  {
    name: 'User Requested Item ID',
    selector: 'objectId',
    sortable: false,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <CustomLink
        text={row.objectId}
        linkTo={`/user-requested-items/${row.objectId}`}
      />
    ),
  },
  {
    name: 'User ID',
    selector: 'user.objectId',
    sortable: false,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <CustomLink
        text={row.user.objectId}
        linkTo={`/users/${row.user.objectId}`}
      />
    ),
  },
  {
    name: 'Created At',
    selector: 'createdAt',
    sortable: true,
    format: (row) => formatDate(row.createdAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A),
  },
  
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
    // eslint-disable-next-line react/display-name
    cell: row => (
      <div className={styles['producer-name-and-avatar']}>
        {!!row.image && <img src={row.image._url} />}
        <div>{row.name}</div>
      </div>
    ),
  },
];

const UserRequestedItems = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [userRequestedItems, setUserRequestedItems] = useState<Record<string, any>>({});

  const fetchAllUserRequestedItemsFn = async () => {
    setLoading(true);
    try {
      const response = await fetchUserRequestedItems({
        ...filters,
        limit: getPageLimit(),
      });
      setUserRequestedItems(response);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUserRequestedItemsFn();
  }, []);

  const onChangePage = (page: number) => {
    filters.page = page - 1;
    fetchAllUserRequestedItemsFn();
  };

  const onChangeRowsPerPage = (rowsPerPage: number, currentPage: number) => {
    filters.limit = rowsPerPage;
    updatePageLimit(rowsPerPage);
    onChangePage(currentPage);
  };

  const getHeader=()=>{
    return (
      <div className={styles['header']}>
        <div className={styles['heading']}>User Requested Items</div>
      </div>
    );
  };
  
  return (
    <>
      {getHeader()}
      <DataTable
        keyField="objectId"
        columns={columns}
        noHeader={true}
        data={userRequestedItems.items}
        highlightOnHover={true}
        defaultSortField="createdAt"
        customStyles={tableStyles}
        pagination={true}
        paginationServer={true}
        paginationPerPage={getPageLimit()}
        paginationDefaultPage={(filters.page || 0) + 1}
        paginationTotalRows={userRequestedItems.total}
        paginationRowsPerPageOptions={[50, 100, 200]}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        loading={loading}
      />
    </>
  );
};

export { UserRequestedItems };
